import { render, staticRenderFns } from "./notificationSwitcher.vue?vue&type=template&id=1a587dfe&"
import script from "./notificationSwitcher.vue?vue&type=script&lang=js&"
export * from "./notificationSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports